import Vue from 'vue';

export default {
  namespaced: true,

  // initial state
  state: {
    user: {},
  },

  // getters
  getters: {
    //
  },

  // actions
  actions: {
    loadUser({ commit }, params) {
      return new Promise((resolve, reject) => {
        Vue.axios.get(`/user`, { params: params })
          .then((response) => {
            commit('setUser', response.data);
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    updateUser({}, params) {
      return new Promise((resolve, reject) => {
        let data = new FormData();

        data.set("user_id", JSON.stringify(params.user_id));
        data.set("fields", JSON.stringify(params.fields));
        data.set("values", JSON.stringify(params.values));

        Vue.axios.put(`/user`, data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));

      });
    },
    updatePassword({}, params) {
      return new Promise((resolve, reject) => {
        let data = new FormData();

        data.set("auth_method", params.auth_method);
        data.set("user_id", params.user_id);
        data.set("new_key", params.new_key);
        data.set("old_key", params.old_key);

        Vue.axios.put(`/auth_method`, data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteUser({ commit }, params) {
      return new Promise((resolve, reject) => {
        let data = new FormData();

        data.set('user_id', params.user_id);

        Vue.axios.delete(`/user`, {data: data})
          .then((response) => {
            commit('deleteUser');
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    addUser({}, params) {
      return new Promise((resolve, reject) => {
        let data = new FormData();

        data.set('auth_method', 0);

        for(let i = 0; i < params.fields.length; i++) {
          data.set(params.fields[i], params.values[i]);
        }

        Vue.axios.post(`/user`, data).then((response) => resolve(response)).catch((error) => reject(error));
      });
    },
    updatePhoto({}, params) {
      return new Promise((resolve, reject) => {
        let data = new FormData();

        data.set('photo', params.photo, params.photo.name);
        data.set('user_id', params.user_id);

        //////////////////////////////////////
        ///Check if user already has a photo an retrieve old photo id

        // Vue.axios.get(`/user?user_id=${params.user_id}`)
          // .then((/* response */) => {
            // if(response.data && response.data.faces && response.data.faces[0]) {
            //   oldPhotoId = response.data.faces[0].id;
            // }

            // let facesdata = new FormData();

            // facesdata.set('face_id', oldPhotoId);

            // Vue.axios.delete(`/face`, { data: facesdata })
            //   .then(() => {
                Vue.axios.post(`/face`, data)
                  .then((response) => resolve(response))
                  .catch((error) => reject(error));
              // })
              // .catch((error) => reject(error));
          // })
      });
    },
  },

  // mutations
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    updateUser(state, user) {
      state.user = user;
    },
    deleteUser(state, user = null) {
      state.user = user;
    },
    addUser(state, user) {
      state.user = user;
    },
    addPhoto(state, photo) {
      if (state.user.faces) {
        state.user.faces.push(photo);
      }
    }
  },
};
